var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36593 7.96892H0.388126V24.0003H5.36593V7.96892ZM5.77351 2.89085C5.77351 1.29697 4.47817 -0.000366211 2.88676 -0.000366211C1.28609 -0.000366211 0 1.29697 0 2.89085C0 4.48472 1.28609 5.78206 2.88676 5.78206C4.47817 5.78206 5.77351 4.48472 5.77351 2.89085ZM13.2584 7.96818H8.50269V23.9996H13.4712V16.0673C13.4712 13.9823 13.8598 11.9529 16.4505 11.9529C19.0042 11.9529 19.0319 14.3437 19.0319 16.2063V23.9996H24.0005V15.2148C24.0005 10.8965 23.066 7.57898 18.0327 7.57898C15.6086 7.57898 13.9894 8.90412 13.3232 10.1644H13.2584V7.96818Z",
    fill: "#007AB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.1f962e52e3c6cfc2369b75a8c8683bf4.svg";
export { ForwardRef as ReactComponent };